import React from 'react';
import styled from 'styled-components';
import {
  minBreakpointQuery,
  standardColours,
  brandColours,
  fontSize,
  standardTransition,
} from '../styles';
import SpaCard from './SpaCard';
import { Link, Svg } from './ui';
import voucherIcon from '../images/voucher-icon.svg';

const StyledSpaItems = styled.div``;

const StyledCta = styled(Link)`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 15px 20px;
  color: ${standardColours.white};
  background-color: ${brandColours.primary};

  ${minBreakpointQuery.small`
    ${fontSize(17)};
  `}

  ${minBreakpointQuery.large`
    ${fontSize(18)};
  `}
  
  svg {
    height: 18px;
    width: 18px;
    fill: ${standardColours.white};

    ${minBreakpointQuery.small`
      height: 20px;
      width: 20px;
    `}

    ${minBreakpointQuery.large`
      height: 22px;
      width: 22px;
    `}
  }

  span {
    position: relative;
    display: inline-block;
    padding-right: 22px;

    ${minBreakpointQuery.small`
      padding-right: 25px;
    `}

    ${minBreakpointQuery.large`
      padding-right: 28px;
    `}

    &:after {
      content: '➔';
      position: absolute;
      top: 50%;
      right: 0;
      transform: translateY(-50%);
      transition: ${standardTransition('transform')};
    }
  }

  &:hover {
    span {
      &:after {
        transform: translateX(3px) translateY(-50%);
      }
    }
  }
`;

const SpaItems = ({
  items,
  removeShortDescription,
  arePackages,
  isSpaList,
  ...props
}) => (
  <StyledSpaItems {...props}>
    {items.map(
      (
        {
          spaId,
          packageId,
          name,
          tags,
          images,
          spaRating,
          city,
          county,
          parentUrl,
          shortDescription,
          packageCount,
          liveAvailability,
          facilities,
          features,
          minPrice,
          higherPrice,
          deal,
          url,
          isChoice,
          isLuxury,
          spa,
          isPricePerPerson,
        },
        i,
      ) => (
        <>
          <SpaCard
            key={arePackages ? `${packageId}-${spa.spaId}` : spaId}
            id={arePackages ? `${packageId}-${spa.spaId}` : spaId}
            name={name}
            images={arePackages ? spa.images : images}
            rating={arePackages ? spa.spaRating : spaRating}
            location={
              arePackages
                ? spa
                : {
                    city: city,
                    county: county,
                    url: parentUrl,
                  }
            }
            shortDescription={!removeShortDescription && shortDescription}
            packageCount={packageCount}
            liveAvailability={liveAvailability}
            featuredPoints={arePackages ? features : facilities}
            minPrice={minPrice}
            higherPrice={higherPrice}
            deal={deal}
            url={url}
            isChoice={arePackages ? spa.isChoice : isChoice}
            isLuxury={isLuxury}
            isSustainable={
              arePackages
                ? (spa.tags || []).includes('Sustainable')
                : (tags || []).includes('Sustainable')
            }
            isPackage={arePackages}
            isPricePerPerson={isPricePerPerson}
            isFirstInSpaList={isSpaList && i === 0}
          />
          {isSpaList && i === 4 ? (
            <StyledCta to="spa-vouchers">
              <Svg image={voucherIcon} />
              <span> Can't decide? Buy a voucher instead</span>
            </StyledCta>
          ) : (
            ''
          )}
        </>
      ),
    )}
  </StyledSpaItems>
);

export default SpaItems;
